import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { ScrollToHash } from './components/layout/ScrollToHash';
import { Home } from './pages/Home';
import { Portfolio } from './pages/Portfolio';
import { PricingPlan } from './pages/PricingPlan';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rk44wzp4wsew">
      <div className="w-full min-h-screen bg-ink font-sans text-white antialiased selection:bg-forge-orange/40" data-id="element-1" data-mp="2rloz2o7je9c8">
        <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-lg focus:bg-forge-orange focus:px-4 focus:py-2 focus:text-sm focus:font-bold focus:text-ink" data-id="element-2" data-mp="2mndr6j0sy8wn">
          Skip to content
        </a>
        <ScrollToHash data-id="element-3" data-mp="28t4j27cxrypu" />
        <Header data-id="element-4" data-mp="28sbbx5a2f776" />
        <main id="main" data-id="element-5" data-mp="23vcjqs9ypabm">
          <Routes data-id="element-6" data-mp="23vulg4fe8gqx">
            <Route path="/" element={<Home data-id="element-8" data-mp="23v2sl1d6kx4c" />} data-id="element-7" data-mp="23ujksdh8vp41" />
            <Route path="/portfolio" element={<Portfolio data-id="element-10" data-mp="3ikqyfyb7r257" />} data-id="element-9" data-mp="3ijxpcqos80jw" />
            <Route path="/pricing-plan" element={<PricingPlan data-id="element-12" data-mp="3mlj9mx3nbh44" />} data-id="element-11" data-mp="3ijfv1zlojwem" />
            <Route path="*" element={<Home data-id="element-14" data-mp="3mk83iqmq9x9u" />} data-id="element-13" data-mp="3mkrefndynled" />
          </Routes>
        </main>
        <Footer data-id="element-15" data-mp="3rcj7c4kla37o" />
      </div>
    </BrowserRouter>;
}